import React from "react";
import Grid from "@material-ui/core/Grid";


function get_number(size) {
  let list = []
  for (var i = 0; i < size; i++) {
    list.push(i);
  }
  return list;
}

function CustomSpacing(props) {
  return (
    <div>
      {get_number(props.spacing).map((tile, index) => (
        <Grid item xs={12}>
          <br></br>
        </Grid>
      ))
      }
    </div>
  );
}

export {CustomSpacing};
